import { butter } from "../plugins/buttercms";

export default {
  methods: {
    async getOccasions() {
      try {
        const page = await butter(this.$config).page.retrieve(
          "*",
          "calendar",
          {
            locale: this.$i18n.locale,
            timeout: 10000
          }
        );
        return page?.data.data.fields.occasions;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
  },
};
